// extracted by mini-css-extract-plugin
module.exports = {"flat":"image-button_flat__dZ1sl","raised":"image-button_raised__pl4uM","disabled":"image-button_disabled__HgfQ9"};